import React from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { useTranslation } from 'react-i18next';

const ResearchStaff = () => {
  const { t } = useTranslation();
  return <PageTemplate title={t('research_staff.title')} />;
};

export default ResearchStaff; 